import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/Modules/user.service';
import TextSignature from 'text-signature';

@Component({
  selector: 'app-user-signature',
  templateUrl: './user-signature.component.html',
  styleUrls: ['./user-signature.component.css']
})
export class UserSignatureComponent implements OnInit, AfterViewInit{
    currentUser: any;
    data: any = {
    fontColor : "Black",
    fontSize:  "16",
    image_height: "",
    image_width: "",
    image_padding_x:"",
    image_padding_y:"",
    mendatory:false
    }
    can = document.getElementById('imgSign');
    image:any
    fontSizes = [ '12','14', '16', '18', '20', '22', '24', '26']
    titles = ["M.D.", "D.O.", "PA-C", "ARNP", "R.N.", "N.P.", "P.A.", "L.Ac", "DNP", "CWS", "CWSP", "WOCN"]

  providerDropdownSettings: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  titleArray: any;
  title: any;

  constructor(private authService: AuthService,
    private toastr: ToastrService,
    private userService:UserService,  
    ) {
    this.currentUser = this.authService.currentUser;
    this.titleArray= this.currentUser.title?this.currentUser.title.split(' , '): [];
    this.title=this.currentUser.title
    this.providerDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'full_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
  };
   }

  ngAfterViewInit() {
    console.log("gonna create sign")
        this.create();

  }
 
  async ngOnInit() {
    //console.log("in user sign component");
    
    this.getSignatureSetting()
    this.data.color = this.currentUser.other_settings?.user_signature_color;
    this.data.fontSize = this.currentUser.other_settings?.user_signature_fontSize;
    //this.create();
    if(this.currentUser.other_settings.user_signature_fontSize === undefined && this.currentUser.other_settings.user_signature_color === undefined) {

  }
}



async getSignatureSetting(){
  //console.log("get usr signature");
  
let response : any = await this.userService.getSignatureSetting().toPromise()
if(response.status == 200){
    let signatureData = response.data.signature_settings;
    this.data.fontSize=signatureData.font_size;
    this.data.fontColor=signatureData.font_color;
    this.data.image_height=signatureData.image_height;
    this.data.image_width=signatureData.image_width;
    this.data.image_padding_x=signatureData.image_padding_x;
    this.data.image_padding_y=signatureData.image_padding_y;
    this.data.image=signatureData.image;
    this.data.mendatory=signatureData.mendatory;
}
}
async saveSignatureSettings() {
  
console.log("saveSignatureSettings", this.data);
let response : any = await this.userService.saveSignatureSettings(this.data).toPromise()
if(response.status == 200){
          let signatureData = response.data.signature_settings;
          //this.data.fontSize=signatureData.font_size;
          //this.data.fontColor=signatureData.font_color;
          //this.data.image_height=signatureData.image_height;
          //this.data.image_width=signatureData.image_width;
          //this.data.image_padding_x=signatureData.image_padding_x;
          //this.data.image_padding_y=signatureData.image_padding_y;
          //console.log("saveSignatureSettings response" , response); 
          this.authService.currentUser = this.currentUser = {
            ...this.currentUser,
            signature_settings: signatureData
          }
  }
  this.toastr.success('Signature Settings Updated Successfully', 'Success');
}
calculateWidth(){
 //console.log(this.data.fontSize);
let index =  this.fontSizes.indexOf(this.data.fontSize+"");
var myString = this.currentUser.first_name+""+this.currentUser.last_name+""+this.title+"";
var stringLength = myString.length;
let width  = 50+((index + 1)*14)+(stringLength*12)
return width 
}
calculateHeight(){
  let index =  this.fontSizes.indexOf(this.data.fontSize+"");
  let height  = 18+((index * 1.3))
  return height
}
changeOptional(e){
  if(e){
    this.data.mendatory=true;
    this.create();
  }
  else
  this.data.mendatory=false;

  this.saveSignatureSettings();

}
create() {
  console.log("in create")
  let optionsParameter = {
    width: this.calculateWidth(),
    height: this.calculateHeight(),
    paddingX: "3",
    paddingY: this.data.fontSize,
    canvasTargetDom: "#can",
    font: [this.data.fontSize+"px", "'Homemade Apple'"],   
    color: "black",
    textString: "",
    customFont: {
      name: "'Homemade Apple'",
      url: "https://fonts.googleapis.com/css?family=Homemade+Apple"
    }
  };
  optionsParameter.textString=`${this.currentUser.first_name} ${this.currentUser.last_name}, ${this.title}`
  //optionsParameter.font.push(`${this.data.font}`)
  let textSignature = new TextSignature(optionsParameter);
  this.can = textSignature.generateImage(optionsParameter);
  let imgData = textSignature.getImageData();
  this.data.image=imgData;
  //console.log("textSignature", textSignature);
  //console.log(" this.image:", this.data);
  console.log(" this.imgData:", imgData);
}
enableButton1(){
  (<HTMLInputElement> document.getElementById("button1")).disabled = false;
}

  onTitleSelect($event) {
    console.log( $event);
    console.log("modelllll.this: : ", this.titleArray);
    if(this.titleArray&&Array.isArray(this.titleArray)){
      this.title=this.titleArray.join(' , ');
    }else if(this.title){
      this.title=this.titleArray;//.join(', ');
    }
  }

  onTitleDeSelect($event) {
    console.log( $event);
    console.log("modelllll.this: : ", this.titleArray);
    if(this.titleArray&&Array.isArray(this.titleArray)){
      this.title=this.titleArray.join(' , ');
    }else if(this.title){
      this.title=this.titleArray;//.join(', ');
    }
  }
  onSelectAllTitle($event) {
    this.titleArray=$event;
    console.log( $event);
    console.log("modelllll.this: : ", this.titleArray);
  }
  onDeSelectAllTitleAll($event) {
    this.titleArray='';
    console.log( $event);
    console.log("modelllll.this: : ", this.titleArray);
  }
  async createSignatureForAllUsers(){
    let users =[ ];
    let data:any; 
    this.userService.getProvidersWithInActiveSignature().subscribe((res:any)=>{
    if(res.data){
      users = res.data;
      console.log("total Users",users.length)
      users.forEach(async (data,index)=>{
        let signatureData = data.signature_settings;
        let optionsParameter = {
          width: this.calculateWidth(),
          height: this.calculateHeight(),
          paddingX: "3",
          paddingY: signatureData.fontSize,
          canvasTargetDom: "#can",
          font: [signatureData.fontSize+"px", "'Homemade Apple'"],   
          color: "black",
          textString: "",
          customFont: {
            name: "'Homemade Apple'",
            url: "https://fonts.googleapis.com/css?family=Homemade+Apple"
          }
        };
        optionsParameter.textString=`${data.first_name} ${data.last_name}, ${data.title}`
        let textSignature = new TextSignature(optionsParameter);
        let can = textSignature.generateImage(optionsParameter);
        let imgData = textSignature.getImageData();
        data.image=imgData;
        let body ={
          id: data._id,
          auth_key: this.currentUser.auth_key,
          is_activated: data.is_activated,
          fontColor:signatureData.font_color,
          fontSize: signatureData.font_size,
          image_height:signatureData.image_height,
          image_width:signatureData.image_width,
          image_padding_x:signatureData.image_padding_x,
          image_padding_y: signatureData.image_padding_y,
          image:data.image,
          mendatory:true
    
        }
        let response : any = await this.userService.saveSignatureSettings(body).toPromise()
        if(response.status == 200){
          console.log("user "+index+" updated successfully")
        }
      })
    }
    else{
      console.error(res.message)
    }
    })
    }
}